import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { TopBarComponent } from '../top-bar/top-bar.component';

/**
 * Shell de l'application (maquette) : barre haute sticky, contenu routé, pied de page.
 * Pas de barre de navigation basse : on arrive toujours par un tag, la navigation se fait
 * par le contenu (fil d'ariane, liens de descente hiérarchique).
 */
@Component({
  selector: 'app-shell',
  imports: [RouterOutlet, TopBarComponent, TranslatePipe],
  templateUrl: './app-shell.component.html',
  styleUrl: './app-shell.component.scss',
})
export class AppShellComponent {}
